export const CLIENT_ID = "d8bc475ca4454c5197562bca87b69626";
export const REDIRECT_URI = "http://loopster.l-uca.com/redirect";
export const AUTH_ENDPOINT = "https://accounts.spotify.com/authorize";
export const RESPONSE_TYPE = "token";
export const SCOPE = "playlist-modify-private user-library-read";
export const TOKEN_VALID_LENGTH = 3600 * 1000;
